import React, { useState, useEffect } from 'react';
import { 
  Box, Typography, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination 
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import DescriptionIcon from '@mui/icons-material/Description';
import { getExpedicoesintransit, handleExpedicaorefresh } from '../services/api';
import OrderDetails from './OrderDetails';  // Ajuste o caminho conforme necessário https://plasticemployers.duckdns.org

const VerPaletes = ({ apiBaseURL, reload }) => {
  const [encomendas, setEncomendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  // Estados para modal de detalhes
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetailsModalOpen, setOrderDetailsModalOpen] = useState(false);

  // Estados para paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

useEffect(() => {
  fetchExpedicoes(); // ← este nome está correto, não fetchPaletes
}, [apiBaseURL, reload]);

  // Fetch
  const fetchExpedicoes = () => {
    getExpedicoesintransit()
      .then(response => {
        console.log("Dados recebidos do backend:2", response.data);
        setEncomendas(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message || 'Erro ao buscar expedições');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchExpedicoes();
  }, []);

  // Atualizar status
  const handleUpdateStatus = async (order_id) => {
    setUpdating(true);
    try {
      const response = await handleExpedicaorefresh(order_id);
      console.log('Status atualizado para order_id', order_id, response.data);
      fetchExpedicoes();
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
    }
    setUpdating(false);
  };

  // Download placeholder
  const handleDownloadFiles = (order_id) => {
    alert(`Download dos ficheiros para Order ID: ${order_id}`);
  };

  // Abrir modal de detalhes
  const handleRowClick = (order) => {
    setSelectedOrder(order);
    setOrderDetailsModalOpen(true);
  };

  const handleDetailsClose = () => {
    setOrderDetailsModalOpen(false);
    setSelectedOrder(null);
  };

  // Paginação
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) return <Typography>Carregando encomendas...</Typography>;
  if (error) return <Typography color="error">Erro: {error}</Typography>;

  // Dados paginados
  const paginated = encomendas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box mt={2}>
      <Typography variant="h6" gutterBottom>Encomendas em Trânsito</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Order ID</strong></TableCell>
              <TableCell><strong>Nome do pedido</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell align="center"><strong>Ações</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginated.map((encomenda, idx) => (
              <TableRow 
                key={encomenda.order_id || idx}
                hover
                style={{ cursor: 'pointer' }}
                onClick={() => handleRowClick(encomenda)}
              >
                <TableCell>{encomenda.order_id}</TableCell>
                <TableCell>{encomenda.invoice_number}</TableCell>
                <TableCell>{encomenda.status_info ? encomenda.status_info.status : 'N/A'}</TableCell>
                <TableCell align="center" onClick={e => e.stopPropagation()}>
                  <Tooltip title="Atualizar Status">
                    <IconButton 
                      onClick={() => handleUpdateStatus(encomenda.order_id)}
                      disabled={updating}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Download dos Ficheiros">
                    <IconButton onClick={() => handleDownloadFiles(encomenda.order_id)}>
                      <DescriptionIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={encomendas.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </TableContainer>

      {/* Modal de Detalhes da Ordem */}
      {orderDetailsModalOpen && selectedOrder && (
        <OrderDetails
          open={orderDetailsModalOpen}
          order={selectedOrder}
          onClose={handleDetailsClose}
          refreshExpedicoes={fetchExpedicoes}
        />
      )}
    </Box>
  );
};

export default VerPaletes;
